<script>
import ModalBus from '../../../../event-bus/modal-bus';
import UnsupportedBanksDecisionPopup from './UnsupportedBanksDecisionPopup.vue';

export default {
  name: 'ShowUnsupportedModalMixin',
  methods: {
    showUnsupportedPopup(source) {
      ModalBus.$emit('open', {
        component: UnsupportedBanksDecisionPopup,
        props: { source },
      });
    },
  },
};
</script>
